module.exports = __webpack_public_path__ + "img/w3_subset_grey.dd22a8b0.png";